var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlackLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78141 0C7.45737 0.000978593 6.38581 1.07547 6.38679 2.39951C6.38581 3.72355 7.45835 4.79804 8.78239 4.79902H11.178V2.40049C11.179 1.07645 10.1064 0.00195719 8.78141 0C8.78239 0 8.78239 0 8.78141 0V0ZM8.78141 6.4H2.39511C1.07107 6.40098 -0.0014642 7.47547 -0.000485607 8.79951C-0.00244279 10.1235 1.0701 11.198 2.39413 11.2H8.78141C10.1054 11.199 11.178 10.1245 11.177 8.80049C11.178 7.47547 10.1054 6.40098 8.78141 6.4Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.952 8.79951C23.953 7.47547 22.8805 6.40098 21.5564 6.4C20.2324 6.40098 19.1598 7.47547 19.1608 8.79951V11.2H21.5564C22.8805 11.199 23.953 10.1245 23.952 8.79951ZM17.5647 8.79951V2.39951C17.5657 1.07645 16.4941 0.00195719 15.17 0C13.846 0.000978593 12.7734 1.07547 12.7744 2.39951V8.79951C12.7725 10.1235 13.845 11.198 15.1691 11.2C16.4931 11.199 17.5657 10.1245 17.5647 8.79951Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1691 24.0002C16.4931 23.9992 17.5657 22.9247 17.5647 21.6006C17.5657 20.2766 16.4931 19.2021 15.1691 19.2011H12.7734V21.6006C12.7725 22.9237 13.845 23.9982 15.1691 24.0002ZM15.1691 17.5991H21.5564C22.8805 17.5981 23.953 16.5236 23.952 15.1996C23.954 13.8755 22.8814 12.801 21.5574 12.7991H15.17C13.846 12.8001 12.7734 13.8746 12.7744 15.1986C12.7734 16.5236 13.845 17.5981 15.1691 17.5991Z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69125e-07 15.1993C-0.000977924 16.5234 1.07156 17.5979 2.3956 17.5989C3.71963 17.5979 4.79217 16.5234 4.79119 15.1993V12.7998H2.3956C1.07156 12.8008 -0.000977924 13.8753 6.69125e-07 15.1993ZM6.38728 15.1993V21.5994C6.38532 22.9235 7.45786 23.998 8.7819 23.9999C10.1059 23.9989 11.1785 22.9244 11.1775 21.6004V15.2013C11.1795 13.8772 10.1069 12.8027 8.78288 12.8008C7.45786 12.8008 6.3863 13.8753 6.38728 15.1993C6.38728 15.1993 6.38728 15.2003 6.38728 15.1993Z",
    fill: "#E01E5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.952,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackLogo);
export default __webpack_public_path__ + "static/media/slack-logo.a3b6176c9be0584571dc5cc152908df4.svg";
export { ForwardRef as ReactComponent };